/** Premium main-page tokens — light + dark. */

export const HOME_PREMIUM_LIGHT = {
    pageBg: "#F7F4EF",
    pageBgSoft: "#FBF9F6",
    pageBackground: "linear-gradient(180deg, #FBF9F6 0%, #F7F4EF 55%, #F3F0EA 100%)",
    cardBg: "rgba(255, 255, 255, 0.78)",
    resumeBg: "#FFFFFF",
    navBg: "#FFFFFF",
    navBorder: "rgba(26, 36, 51, 0.08)",
    navShadow: "0 -4px 18px rgba(26, 36, 51, 0.04)",
    navInactive: "#8B95A1",
    text: "#1A2433",
    textMuted: "#4A5563",
    textSubtle: "#64707D",
    teal: "#2EC4B6",
    tealSoft: "rgba(46, 196, 182, 0.14)",
    tealRing: "rgba(46, 196, 182, 0.45)",
    goldMetal:
        "linear-gradient(185deg, #FFF6D0 0%, #F2D978 16%, #E4BC3C 42%, #C9921A 68%, #E8C547 88%, #FFF0B0 100%)",
    goldText: "#1A2433",
    pillSelectedBg: "#FFFAF3",
    pillSelectedText: "#2C3A4A",
    pillInactiveBg: "#E8E6E1",
    pillInactiveText: "#5C6570",
    lockMuted: "#B0B6BE",
    cardBorder: "rgba(44, 58, 74, 0.08)",
    resumeBorder: "rgba(44, 58, 74, 0.1)",
    cardShadow: "0 10px 32px rgba(44, 58, 74, 0.08)",
    resumeShadow: "0 6px 20px rgba(44, 58, 74, 0.06)",
    mistWash:
        "linear-gradient(155deg, rgba(190, 225, 250, 0.55) 0%, rgba(230, 244, 252, 0.35) 45%, rgba(210, 232, 248, 0.45) 100%)",
    mistBlobA:
        "radial-gradient(ellipse at 40% 45%, rgba(110, 185, 240, 0.55) 0%, rgba(170, 215, 248, 0.28) 48%, transparent 72%)",
    mistBlobB:
        "radial-gradient(ellipse at 60% 40%, rgba(90, 170, 230, 0.48) 0%, rgba(180, 220, 250, 0.26) 50%, transparent 74%)",
    mistBlobC:
        "radial-gradient(ellipse at 50% 65%, rgba(130, 200, 245, 0.5) 0%, rgba(200, 230, 250, 0.24) 50%, transparent 75%)",
    mistHaze:
        "linear-gradient(90deg, transparent 0%, rgba(120, 190, 240, 0.28) 48%, rgba(180, 220, 255, 0.2) 58%, transparent 100%)",
    bubbleFill:
        "radial-gradient(circle at 30% 28%, #fff 0%, rgba(150, 210, 245, 0.7) 48%, rgba(90, 170, 225, 0.2) 100%)",
    bubbleBorder: "rgba(140, 200, 240, 0.85)",
    bubbleShadow: "0 2px 8px rgba(70, 150, 210, 0.25), inset 0 0 6px rgba(255,255,255,0.8)",
};

export const HOME_PREMIUM_DARK = {
    pageBg: "#0B1424",
    pageBgSoft: "#12203A",
    pageBackground: "linear-gradient(180deg, #12203A 0%, #0B1424 48%, #070E1A 100%)",
    cardBg: "rgba(21, 37, 63, 0.82)",
    resumeBg: "#15253F",
    navBg: "#0A1220",
    navBorder: "rgba(46, 196, 182, 0.2)",
    navShadow: "0 -6px 24px rgba(0, 0, 0, 0.35)",
    navInactive: "rgba(214, 226, 240, 0.45)",
    text: "#F4F7FB",
    textMuted: "rgba(214, 226, 240, 0.68)",
    textSubtle: "rgba(214, 226, 240, 0.5)",
    teal: "#2EC4B6",
    tealSoft: "rgba(46, 196, 182, 0.2)",
    tealRing: "rgba(46, 196, 182, 0.5)",
    goldMetal:
        "linear-gradient(185deg, #FFF6D0 0%, #F2D978 16%, #E4BC3C 42%, #C9921A 68%, #E8C547 88%, #FFF0B0 100%)",
    goldText: "#1A2433",
    pillSelectedBg: "rgba(46, 196, 182, 0.22)",
    pillSelectedText: "#7FE8DB",
    pillInactiveBg: "rgba(255, 255, 255, 0.08)",
    pillInactiveText: "rgba(214, 226, 240, 0.72)",
    lockMuted: "rgba(214, 226, 240, 0.4)",
    cardBorder: "rgba(255, 255, 255, 0.12)",
    resumeBorder: "rgba(255, 255, 255, 0.12)",
    cardShadow: "0 14px 40px rgba(0, 0, 0, 0.4)",
    resumeShadow: "0 8px 28px rgba(0, 0, 0, 0.35)",
    mistWash:
        "linear-gradient(155deg, rgba(40, 90, 140, 0.55) 0%, rgba(30, 60, 100, 0.35) 45%, rgba(46, 120, 160, 0.4) 100%)",
    mistBlobA:
        "radial-gradient(ellipse at 40% 45%, rgba(60, 150, 210, 0.45) 0%, rgba(40, 100, 160, 0.22) 48%, transparent 72%)",
    mistBlobB:
        "radial-gradient(ellipse at 60% 40%, rgba(46, 196, 182, 0.28) 0%, rgba(50, 120, 180, 0.18) 50%, transparent 74%)",
    mistBlobC:
        "radial-gradient(ellipse at 50% 65%, rgba(80, 160, 220, 0.4) 0%, rgba(40, 90, 140, 0.2) 50%, transparent 75%)",
    mistHaze:
        "linear-gradient(90deg, transparent 0%, rgba(70, 160, 220, 0.28) 48%, rgba(46, 196, 182, 0.16) 58%, transparent 100%)",
    bubbleFill:
        "radial-gradient(circle at 30% 28%, rgba(255,255,255,0.9) 0%, rgba(120, 200, 230, 0.45) 48%, rgba(46, 160, 200, 0.15) 100%)",
    bubbleBorder: "rgba(140, 210, 240, 0.55)",
    bubbleShadow: "0 2px 10px rgba(0, 0, 0, 0.35), inset 0 0 6px rgba(255,255,255,0.45)",
};

/** @deprecated use getHomePremium(isDark) */
export const HOME_PREMIUM = HOME_PREMIUM_LIGHT;

export function getHomePremium(isDark = false) {
    return isDark ? HOME_PREMIUM_DARK : HOME_PREMIUM_LIGHT;
}

export function homePremiumShellSx(isDark = false) {
    const t = getHomePremium(isDark);
    return {
        bgcolor: t.pageBg,
        background: t.pageBackground,
        color: t.text,
    };
}

export function homePremiumGlassCardSx(isDark = false) {
    const t = getHomePremium(isDark);
    return {
        position: "relative",
        bgcolor: t.cardBg,
        background: t.cardBg,
        border: `1px solid ${t.cardBorder}`,
        boxShadow: t.cardShadow,
        backdropFilter: "blur(8px)",
        WebkitBackdropFilter: "blur(8px)",
    };
}

export function homePremiumResumeCardSx(isDark = false) {
    const t = getHomePremium(isDark);
    return {
        position: "relative",
        bgcolor: t.resumeBg,
        background: t.resumeBg,
        border: `1px solid ${t.resumeBorder}`,
        boxShadow: t.resumeShadow,
        boxSizing: "border-box",
        maxWidth: "100%",
        overflow: "hidden",
    };
}

export function homePremiumHeroSx() {
    return {
        position: "relative",
        width: "100%",
        maxWidth: "100%",
        mb: 1.25,
        pt: 0.5,
        pb: 1,
        px: 0,
        boxSizing: "border-box",
        background: "transparent",
        overflow: "visible",
    };
}

export function homePremiumNavBarSx(isDark = false) {
    const t = getHomePremium(isDark);
    return {
        bgcolor: t.navBg,
        borderTop: `1px solid ${t.navBorder}`,
        boxShadow: t.navShadow,
    };
}
